import type { TaskModel } from '../types/task.model';
import type { FilterStatusType } from '@/app/types/TaskStatusFilter';

export const filterByStatus = (tasks: TaskModel[], filterStatus: FilterStatusType) => {
	if (filterStatus === 'all') {
		return tasks;
	}

	if (filterStatus === 'attention') {
		return tasks.filter((t) => t.status === 'all_rejected' || t.status === 'overdue');
	}

	return tasks.filter((t) => t.status === filterStatus);
};
